import React, { useState } from "react";
import axios from 'axios';
import API from '../../API';
import './needMorePros.css';

const NeedMorePros = ({ project_id, setHideButton }) => {
    const [notifiedPopup, setNotifiedPopup] = useState(false);
    const [notifiedNoti, setNotifiedNoti] = useState(false);
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(true);

    const notifyPros = () => {
        setLoading(true);
        const data = { not_yet_hired: "not interested with any provider" }
        axios.post(API.baseURL + `/v2/customers/projects/${project_id}/not_yet_hired`, data, API.options)
            .then(response => response.data)
            .then(() => {
                setLoading(false);
                setNotifiedPopup(true);
                setHideButton(true);
            }).catch(() => {
                setLoading(false);
            })
    }

    const handleClose = () => {
        setNotifiedPopup(false);
        setNotifiedNoti(true);
        setTimeout(() => {
            setShow(false);
            window.location.href = `/project-detail/${project_id}/my_projects`;
        }, 5000);
    }

    if (!show) return null;

    return (
        <>
            {notifiedNoti ? (
                <div onClick={notifyPros} className="ec-notification-slide">
                    <div className="notification-icon">
                        <div className="pulse-icon">
                            <img src="/assets/icon/notification/notification-1f.svg" alt="notification" />
                        </div>
                    </div>
                    <div className="notification-content">
                        <p>
                            As per your request, we have notified
                            relevant new providers to contact you.
                        </p>
                    </div>
                </div>
            ) : (
                <div className="ec-card mb-5">
                    <div className="card-content d-flex justify-content-between flex-wrap">
                        <div>
                            <p className="card-title">Need more providers?</p>
                            <p className="card-description">
                                Get more providers to contact you for your project.
                            </p>
                        </div>
                        <div className="button-container">
                            <button 
                                onClick={notifyPros} 
                                className="request-button"
                                disabled={loading}
                            >
                                Request More Providers
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {loading && (
                <div className="loading-overlay">
                    <div className="loading-spinner"></div>
                    <div style={{
                        color: '#fff',
                        marginTop: '10px',
                        fontSize: '16px',
                        fontWeight: '500'
                    }}>
                        Loading...
                    </div>
                </div>
            )}

            {notifiedPopup && (
                <div className="modal-overlay">
                    <div className="modal-content p-4">
                        <div>
                            <h3>Providers Notified!</h3>
                            <p>Relevant new providers will contact you shortly.</p>
                        </div>
                        <div>
                            <button onClick={handleClose} className="close-button">
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default NeedMorePros;
